import React from 'react';
import { useNavigate } from 'react-router-dom';
import beerIcon from "../assets/page_logo.png";
import mailIcon from '../assets/mail.png';

function Footer() {
  const navigate = useNavigate();

  return (
    <footer style={{ backgroundColor: "#F9F5EA", borderTop: "1px solid #eee" }}>
      <div
        style={{
          maxWidth: "1440px",
          margin: "0 auto",
          padding: "clamp(20px, 5vw, 40px) 20px 0",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "clamp(14px, 4vw, 40px)",
        }}
      >
        {/* Left Column */}
        <div style={{ maxWidth: "280px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <img
              onClick={() => navigate("/")}
              src={beerIcon}
              alt="MyHoom logo"
              style={{
                width: "clamp(46px, 13vw, 67px)",
                height: "auto",
                cursor: "pointer",
              }}
            />
            <h2
              style={{
                margin: 0,
                color: "#DE810E",
                fontSize: "clamp(18px, 5vw, 24px)",
              }}
            >
              my HOOM
            </h2>
          </div>
        </div>

        {/* Right Column */}
        <div style={{ maxWidth: "280px" }}>
          {/* Mail icon + text */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div
              style={{
                backgroundColor: "#DE810E",
                borderRadius: "12px",
                width: "clamp(44px, 11vw, 47px)",
                height: "clamp(44px, 11vw, 47px)",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() =>
                window.open(
                  "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=contact@myhoom.com",
                  "_blank",
                  "noopener,noreferrer",
                )
              }
            >
              <img
                src={mailIcon}
                alt="Email"
                style={{ width: "20px", height: "20px" }}
              />
            </div>

            <span
              style={{
                fontSize: "14px",
                color: "#000",
                cursor: "pointer",
              }}
              onClick={() =>
                window.open(
                  "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=contact@myhoom.com",
                  "_blank",
                  "noopener,noreferrer",
                )
              }
            >
              contact@myhoom.com
            </span>
          </div>
        </div>

        {/* Horizontal Line */}
        <div style={{ width: "100%", margin: 0, padding: 0 }}>
          <hr
            style={{
              margin: "0",
              border: "none",
              borderTop: "1px solid #ddd",
            }}
          />
        </div>

        {/* Bottom Section */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "2px 0 12px 0",
            flexWrap: "wrap",
            fontSize: "14px",
          }}
        >
          {/* Left */}
          <p style={{ color: "#000", margin: 0 }}>
            © {new Date().getFullYear()} my HOOM.LLC. All rights reserved.
          </p>

          {/* Right */}
          <p style={{ color: "#DE810E", margin: 0 }}>
            <span
              style={{ marginRight: "15px", cursor: "pointer" }}
              onClick={() => navigate("/privacy")}
            >
              Privacy Policy
            </span>
            |
            <span
              style={{ marginLeft: "15px", cursor: "pointer" }}
              onClick={() => navigate("/terms-of-use")}
            >
              Terms of Use
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
